export default "__VITE_ASSET__CLTrZGLS__"